import React, { useState, useEffect } from 'react'
// import parkingpayments from '../../../assets/img/parkingpayments.png'
// import emailImage from '../../../assets/img/email.png'
// import keyImage from '../../../assets/img/key.png'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../../constants/errorMessage'
import { Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap'
import { Circles } from 'react-loader-spinner'
import { useForm } from 'react-hook-form'
import { userSingIn } from '../../../redux/actions/singinAndSingUp'
import { useNavigate } from 'react-router'
import { getConfigDetails } from '../../../services/config'
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon } from '../../../constants/globalConstants'
import { getPartnerLogo } from '../../../utils/helper'
// import { getPartnerDetailsBySLug } from '../../../redux/actions/userDetails'
import NoData from '../../NoData'
import { addEventLog } from '../../../redux/actions/EventsLog'
import CONSTANTS from '../../../redux/constants'
require('./login.scss')

function Login(props) {
  const { dispatch, loader, notify, isFetching , partnerDetails} = props
  const partner = window.location.toString().split('/')[3]
  const { register, handleSubmit, formState: { errors }, reset } = useForm()

  const [userEmail, setUserEmail] = useState('')

  const [passwordShown, setPasswordShown] = useState(false)
  const [cpasswordShown, setCPasswordShown] = useState(false)
  const [mpasswordShown, setMPasswordShown] = useState(false)
  const [isValidPartner, setIsValidPartner] = useState(false)
  const [partnerData, setPartnerData] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const getEmailUer = JSON.parse(localStorage.getItem('userEmail'))
    reset(formValues => ({ ...formValues, 'username': getEmailUer }))
  }, [EMPTY_ARRAY])

  useEffect(() => {
		if(partner){
			// dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
				if (partnerDetails?.email) {
					setPartnerData(partnerDetails)
					setIsValidPartner(true)
					localStorage.removeItem('partnerData')
					localStorage.setItem('partnerData',JSON.stringify(partnerDetails))
					const partnerData = partnerDetails
					const color = partnerData?.brand_setting?.color
					const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
					if(color){
						document.documentElement.style.setProperty('--bs-primary',color)
						document.documentElement.style.setProperty('base-color',color)
						document.documentElement.style.setProperty('primary',color)
						document.documentElement.style.setProperty('textcolor',color)
						document.documentElement.style.setProperty('--bs-btn-bg',color)
						document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
						document.documentElement.style.setProperty('--bs-list-group-active-border-color',color)
						document.documentElement.style.setProperty('--bs-list-group-active-color',color)
						document.documentElement.style.setProperty('--bs-list-group-active-bg',color)
					}
					
				} else {
					if(partnerDetails?.email){
            setIsValidPartner(true)
          }else{
              setIsValidPartner(false)
          }
					localStorage.removeItem('partnerData')
				}
				
			// }).catch(() => {
			// 	console.log('error')
				
			// })
		}
		
	},[EMPTY_ARRAY, partnerDetails])
  const togglePasswordVisiblity = (e, key) => {
    if (key === 'password') { setPasswordShown(passwordShown ? false : true) }
    if (key === 'mpassword') { setMPasswordShown(mpasswordShown ? false : true) }
    if (key === 'cpassword') { setCPasswordShown(cpasswordShown ? false : true) }
  }



  const handleRemeberme = (e) => {
    const { checked } = e.target
    if (checked) { localStorage.setItem('userEmail', JSON.stringify(userEmail !== '' ? userEmail : '')) }
    else if (!checked) { localStorage.removeItem('userEmail') }
  }

  const handleChangeInput = (e) => {
    const { name, value } = e.target
    if (name === 'username') { setUserEmail(value) }
  }

  const onSignIn = (data) => {
    if (!loader) {
      if (data?.username !== '' && data?.password !== '') {
        const payloadKeys = { 'client_id': getConfigDetails().CLIENT_ID, 'client_secret': getConfigDetails().CLIENT_SECRET, 'grant_type': 'password' }
        const finalPayload = { ...payloadKeys, ...data }
        delete finalPayload?.rememberMe
        dispatch(userSingIn(finalPayload)).then((res) => {
          if (res?.status === 201 && res?.data !== null) {
            localStorage?.setItem('sign_in', JSON.stringify(res?.data))
            notify('success', 'User Login Successfully')
            reset(formValues => ({ ...formValues, 'username': '', 'password': '' }))
            const pushBack = JSON.parse(localStorage.getItem('history'))
            if(pushBack?.route && pushBack?.facility){
                navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            }else{
                navigate(`/${partner}`)
            }
            // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
            // navigate(0)
          } else {
            notify('error', res?.errors?.message)
          }
        }).catch((err) => {
          let errObject = { 
            payload: finalPayload,
            error: err,
            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong  
        }
        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} userSingIn-login.js-105`))
          notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
      }
    }

  }

  const handleCreateAccount = () => {
    navigate(`/${partner}/signup`)
    // navigate(0)
  }
  const handleForgotPassword = () => {
    navigate(`/${partner}/send-email`)
    // navigate(0)
  }

  return (
    isFetching ? null : isValidPartner ? <div>
      <Container className='mt-5 mb-3 m-auto loginComp'>
        <img width='230' src={partnerData ? partnerData?.brand_setting?.logourl : getPartnerLogo(partner)} alt={partner ? partner : 'e-Ticket'} />
        <p className='textloginNotes'>{errorMessage?.loginNotes}</p>
      </Container>

      <Form onSubmit={handleSubmit(onSignIn)}>
        <Container>
          <Card>
            <InputGroup>
              <InputGroup.Text id="inputLoginImage iconWidth"><span style={{ height: '22px', width: '22px' }}>{getSvgIcon('Email' , 'var(--bs-primary)')}</span></InputGroup.Text>
              <Form.Control
                type="email"
                name='username'
                aria-describedby="basic-addon1"
                className='form-control inputLogin'
                id='loginInput'
                maxLength='40'
                minLength='1'
                placeholder="Enter Email Address"
                {...register('username', {
                  required: { value: true, message: 'This field is required' },
                  pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Please enter a valid Email Address' },
                  onChange: (e) => handleChangeInput(e),
                })} />
            </InputGroup>
            <InputGroup className='inputBorderUpper myiconset'>
              <InputGroup.Text id="inputLoginImage iconWidth"><span style={{ height: '22px', width: '22px' }}>{getSvgIcon('Password' , 'var(--bs-primary)')}</span></InputGroup.Text>
              <Form.Control type={passwordShown ? 'text' : 'password'} name='password' className="form-control passwordInput inputLogin" id="loginInput" placeholder="Enter Password" aria-describedby="basic-addon1"  {...register('password', { required: true })} />
              <i className={passwordShown ? 'fas fa-eye-slash loginPassIcon' : 'fas fa-eye loginPassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
            </InputGroup>
          </Card>
          {(errors?.username?.type === 'required' && errors?.password?.type === 'required') && <span style={{ color: 'red', fontSize: '13px' }}>Both field are required</span>}
          {(errors?.username?.type !== 'required' && errors?.username?.type === 'pattern' && errors?.password?.type === 'required') && <span style={{ color: 'red', fontSize: '13px' }}>{errors?.username?.message}</span>}
          {(errors?.username?.type !== 'required' && errors?.username?.type === 'pattern' && errors?.password?.type !== 'required') && <span style={{ color: 'red', fontSize: '13px' }}>{errors?.username?.message}</span>}
          {(errors?.username?.type !== 'required' && errors?.password?.type === 'pattern' && errors?.password?.type !== 'required') && <span style={{ color: 'red', fontSize: '13px' }}>{errors?.password?.message}</span>}
          {(errors?.username?.type !== 'required' && errors?.username?.type !== 'pattern' && errors?.password?.type === 'required') && <span style={{ color: 'red', fontSize: '13px' }}>Password field is required</span>}
          {(errors?.username?.type === 'required' && errors?.password?.type !== 'required') && <span style={{ color: 'red', fontSize: '13px' }}>Email field is required</span>}
        </Container>

        <Container className='mt-4'>
          <Row>
            <Col>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" name='rememberMe' id="checkboxRemember" {...register('rememberMe', {
                  onChange: (e) => handleRemeberme(e)
                })} />
                <label className="form-check-label" id='LoginlableCheckBox'>
                  Remember me
                </label>
              </div>
            </Col>
            <Col>
              <label className="form-check-label" id='loginForgotPassword' onClick={handleForgotPassword}>Forgot Password?</label>
            </Col>
          </Row>
        </Container>

        <Container className="mt-3">
          <button type="submit" name="submit" disabled={loader} className="btn w-100 my-4 text-white bg-primary">
            <div className='d-flex justify-content-center align-items-center'>
              <span>Login </span>  <span className='ms-2'>
                {(loader) ? <Circles
                  height="20"
                  width="20"
                  style={{ display: 'inline-block' }}
                  color="#ffffff"
                  ariaLabel="circles-loading"
                  visible={true}
                /> : null}
              </span>
            </div>
          </button>
        </Container>

        <Container className='loginComp'>
          <Row>
            <Col><hr className='dashMarkLoginStart' /></Col>
            <Col className='CircleContainerBadge'><div className="circle">Or</div></Col>
            <Col><hr className='dashMarkLoginEnd' /></Col>
          </Row>
        </Container>

        <Container>
          <button type='button' className="btn border-primary text-primary w-100 my-4" onClick={handleCreateAccount}>Create Account</button>
        </Container>
      </Form>
    </div> : <NoData message={errorMessage?.invalidPartner}/>
  )
}


Login.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  notify: PropTypes.func,
  isFetching: PropTypes.bool,
  partnerDetails: PropTypes.object,
}

Login.defaulProps = {
  dispatch: noop,
  loader: false,
  notify: noop,
  isFetching: true,
  partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ singInAndSingUp, userDetailsReducer }) {
  return {
    loader: singInAndSingUp?.loader,
    isFetching: userDetailsReducer?.isFetching,
  }
}
export default connect(mapStateToProps)(Login)